import InitialState from "./InitialState"
import {FETCH_ACCOUNT_DATA_SUCCESS, UPDATE_USER_ID} from "../actions/ActionTypes"

export const AccountDataReducer = function(initialState = InitialState.accountData, action: any){
    switch (action.type) {
        case FETCH_ACCOUNT_DATA_SUCCESS:
            return Object.assign({}, action.accountData);
        case UPDATE_USER_ID:
            let roles = [...initialState.memberships];
            roles[0].userId = action.userId;
            return { ...initialState, roles };
        default:
            return initialState;
    }
}